
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { key } from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faEye,
  faStar,
  faBell,
  faPhone,
  faCaretDown,
  faCaretUp,
  faCaretRight
} from "@fortawesome/free-solid-svg-icons";

library.add( faEye, faStar, faBell, faPhone, faCaretDown, faCaretUp, faCaretRight );

@Options( {
  props      : {
    gm  : {
      type     : Object,
      required : true
    },
    map : {
      type    : Boolean,
      default : false
    }
  },
  components : {
    FontAwesomeIcon
  }
} )
export default class Map extends Vue
{
  store = useStore( key );

  TOOLTIP_PROMO = "Cet établissement offre des promotions sur les box !";
}
